import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default, { withTheme } from 'styled-components';
import themes from '../../theming/themes.js';
import React from 'react';

var _excluded = ["label", "value", "style", "small", "theme"];
var _templateObject, _templateObject2;
var GrayTextDiv = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 0.875rem;\n  display: flex;\n  flex-direction: column;\n  height:100%;\n  justify-content: space-between;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grayDark;
});
var ValueDiv = styled__default('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 350;\n  font-size: ", ";\n  border-bottom: ", ";  \n  flex-grow: 0;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayDark;
}, function (_ref3) {
  var $small = _ref3.$small;
  return $small ? '1rem' : '1.125rem';
}, function (_ref4) {
  var theme = _ref4.theme;
  return "2px solid ".concat(theme.palette.grayLighter);
});
var DisplayField = function DisplayField(_ref5) {
  var label = _ref5.label,
    value = _ref5.value,
    style = _ref5.style,
    small = _ref5.small,
    _ref5$theme = _ref5.theme,
    theme = _ref5$theme === void 0 ? themes["default"] : _ref5$theme,
    rest = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(GrayTextDiv, _extends({
    style: style,
    theme: theme
  }, rest), label, /*#__PURE__*/React.createElement(ValueDiv, {
    theme: theme,
    $small: small
  }, value, "\xA0"));
};
var index = withTheme(DisplayField);

export default index;
export { GrayTextDiv };
